import _toArray from "@babel/runtime/helpers/toArray";
import { makeExponentsArray } from './exponents';
export var nInputsPolynomial = function nInputsPolynomial(polynomialCoefficients, termPowers, variables) {
  var result = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (termPowers.length === 0) {
    return result;
  }

  var _termPowers = _toArray(termPowers),
      currentTermPowers = _termPowers[0],
      restOfTermPowers = _termPowers.slice(1);

  var _polynomialCoefficien = _toArray(polynomialCoefficients),
      currentCoefficient = _polynomialCoefficien[0],
      restOfPolynomialCoefficients = _polynomialCoefficien.slice(1);

  var i = 0;
  var product = 1;
  var length = variables.length;

  for (; i < length; i++) {
    product *= Math.pow(variables[i], currentTermPowers[i]);
  }

  return nInputsPolynomial(restOfPolynomialCoefficients, restOfTermPowers, variables, result + product * currentCoefficient);
};
export var mapColorSpace = function mapColorSpace(coefficientMatrix, degree) {
  var termPowers = makeExponentsArray(3, degree);
  return function (color) {
    return [nInputsPolynomial(coefficientMatrix[0], termPowers, color), nInputsPolynomial(coefficientMatrix[1], termPowers, color), nInputsPolynomial(coefficientMatrix[2], termPowers, color)];
  };
};
//# sourceMappingURL=index.js.map